import React from "react";
import { Link, useLocation } from "react-router-dom";
import navbarData from "../../../data/Navbar/navbar";

function NavbarItem() {
  const location = useLocation();
  const basePath = process.env.PUBLIC_URL || "";

  const isAbsoluteUrl = (url = "") => /^https?:\/\//i.test(url);

  const renderNavLink = (item, children, extraProps = {}) => {
    const link = (item?.link ?? "").toString();
    const comingSoon = item?.comingSoon === true;

    // Coming soon -> always disabled
    if (comingSoon) {
      return (
        <a
          href={link || "#"}
          className={`disabled ${extraProps.className || ""}`.trim()}
          aria-disabled="true"
          onClick={(e) => e.preventDefault()}
          {...extraProps}
        >
          {children}
        </a>
      );
    }

    // External absolute url
    if (item?.external === true || isAbsoluteUrl(link)) {
      return (
        <a href={link} rel="noopener noreferrer" {...extraProps}>
          {children}
        </a>
      );
    }

    // Empty / hash -> treat as non-navigation (parent Product)
    if (!link || link === "#") {
      return (
        <a
          href="#"
          onClick={(e) => e.preventDefault()}
          {...extraProps}
        >
          {children}
        </a>
      );
    }

    // Internal route
    return (
      <Link to={`${basePath}${link}`} {...extraProps}>
        {children}
      </Link>
    );
  };

  return (
    <>
      {navbarData.map((item) => {
        const itemLink = (item.link ?? "").toString();

        // active state (only for internal links that exist)
        const isActive =
          itemLink &&
          !isAbsoluteUrl(itemLink) &&
          itemLink !== "#" &&
          location.pathname === `${basePath}${itemLink}`;

        return (
          <li
            key={item.id}
            className={`${item.subMenu || item.megaMenu ? "has-submenu" : ""} ${
              isActive ? "active" : ""
            }`}
          >
            {renderNavLink(
              item,
              item.title,
              {
                style: {
                  fontWeight: isActive ? "500" : "300",
                  letterSpacing: isActive ? "-0.44px" : "inherit",
                  color: isActive ? "#E12426" : "inherit",
                },
              }
            )}

            {item.subMenu && (
              <ul className="submenu-nav">
                {item.subMenu.map((subItem, index) => (
                  <li key={index}>
                    {renderNavLink(
                      subItem,
                      <>
                        <span className="item-left">
                          <span className="title">{subItem.title}</span>
                          {subItem.desc && (
                            <span className="desc">{subItem.desc}</span>
                          )}
                        </span>

                        {subItem.comingSoon && (
                          <span className="badge">Coming soon</span>
                        )}
                      </>
                    )}
                  </li>
                ))}
              </ul>
            )}

            {item.megaMenu && (
              <ul className="submenu-nav submenu-nav-mega">
                {item.megaMenu.map((megaItem, indx) => (
                  <li key={indx} className="mega-menu-item">
                    {renderNavLink(megaItem, megaItem.title)}
                    <ul>
                      {megaItem.lists?.map((listItem, idx) => (
                        <li key={idx}>
                          {renderNavLink(listItem, listItem.title)}
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            )}
          </li>
        );
      })}
    </>
  );
}

export default NavbarItem;